import { Expose } from "class-transformer";

export class CreateSupplierDto {
  @Expose()
  code: string;

  @Expose()
  name: string;

  @Expose()
  businessName: string;

  @Expose()
  vatNumber: string;
}
